<template>
<div class="flex justify-center items-center h-full">
    <v-select
      v-if="params.data.invoice_payment_status_id !== 1"
      style="width: 120px"
      append-to-body
      v-model="params.data.invoice_payment_status_id"
      :options="paymentStatus"
      label="paymentName"
      :reduce="(option) => option.id"
      :class="`payment_stat_fin pay_status_${params.data.invoice_payment_status_id}`"
      :clearable="false"
      :searchable="false"
      @input="params.colDef.CellRendererParams.changeStatus(params.data)"
    >
    </v-select>
    <span
      v-else
      class="payment_stat_fin pay_status_1 inline-flex items-center"
      style="width: 120px; height: 36px; color: #fff; padding: 8px;"
    >
      {{ params.data.invoice_payment_status }}
    </span>
</div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'PaymentStatusCell',
  components: {
    vSelect
  },
  data () {
    return {
      paymentStatus: [
        { id: 1, paymentName: 'Paid' },
        { id: 2, paymentName: 'Unpaid' }
      ]
    }
  }
}
</script>